/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

interface Props {
	label: string;
	value: number;
	unit: string;
	isVariance?: boolean;
}

const SReconcileStatCard: React.FC<Props> = ({ label, value, unit, isVariance = false }) => {
  const isNegative = value < 0;
  const isPositive = value > 0;

  // Determine border and text colors for the variance card
  const borderClass = isVariance ? "border-2 border-red-400" : "border border-gray-200";
  const valueColor = isVariance
    ? (isNegative ? "text-red-500" : "text-emerald-500")
    : "text-slate-800";

  // Format value with sign for variance
  const formattedValue = value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className={`bg-white px-8 py-2 rounded-xl shadow-sm ${borderClass}`}>
      <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">
        {label}
      </p>
      <div className="flex items-baseline gap-2">
        <span className={`text-4xl font-black ${valueColor}`}>
          {isVariance && isPositive ? "+" : ""}
          {formattedValue}
        </span>
        <span className="text-sm font-bold text-slate-400 uppercase tracking-widest">
          {unit}
        </span>
      </div>
    </div>
  );
};

export default SReconcileStatCard;
